import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Title from "../../../components/Title";
import { DataGrid } from '@material-ui/data-grid';
import Message from "../../tools/Message";
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import { useNavigate, useLocation } from 'react-router-dom';
import UserNotactifService from "../../../services/UserNotactifService";
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FonctionService from "../../../services/FonctionService";
import FundingService from "../../../services/FundingService";
import DirectionService from "../../../services/DirectionService";
import DialogContentText from '@mui/material/DialogContentText';
import { Grid } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Phone from "../../tools/Phone";
import Spacer from "../../../components/Spacer";
import Alert from "@material-ui/lab/Alert";
import { LoadingButton } from '@mui/lab';
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  TextField,
    Chip,
  Checkbox,
  ListItemText
} from "@material-ui/core";
import PlanningService from "../../../services/PlanningService";
import UserService from "../../../services/UserService";
const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

export default function UserTable(props) {

  const location = useLocation();
  const name=props.name;
   const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const classes = useStyles();
  const [details, setDetails] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [direction,setDirection]=useState([]);
  const [service,setService]=useState([]);
  const [fonction,setFonction]=useState([]);
  const [funding,setFunding]=useState([]);
  const [isValidEmail, setIsvalidEmail] = useState(false);
  const regexForEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[A-Za-z]+$/;
  const [number, setNumber] = useState(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ' ', '']);
  const [compt, setCompt] = useState(false);
  const [isPhoneNumberEmpty, setIsPhoneNumberEmpty] = useState(false);
  const [isPhoneNumberLengthNotValid, setPhoneNumberLengthNotValid] = useState(false);
  const [isloading,setIsloading]=useState(false);
  const [serviceSupHierarchique, setServiceSupHierarchique] = useState([]);
  const [idserviceSupHierarchique, setIdserviceSupHierarchique] = useState(0);
  const [form,setForm]=useState({
     person_id:"",
     direction_id:null,
     service_id:null,
     fonction_id:null,
     funding_id:null,
     email:"",
     registration_number:"",
     telephone:"",
     group:[],
     usersup:null,
     date_notif:"",
     date_prise:"",
     date_fin:"",
     motif:""
  });

  const [message, setMessage] = React.useState({
    openMessage: false,
    color: 'green',
    messageInfo: '',
  });
  const { openMessage, color, messageInfo } = message;

  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);
  const [tests, setTests] = useState([]);
  const [users, setUsers] = useState([]);
  const [afficheerreur,setAfficheerreur]=useState(false);


  const handleCloseErreur  = () => {
    setAfficheerreur(false);
  };

  function handleChangeServiceSupHierarchique(ev) {
          const {value } = ev.target;
          setIdserviceSupHierarchique(value);
          UserService.getAllUserByService(false, value,0).then((results) => {
            if (results && results.status) {
              setUsers(results.data);
            }
          });
  }

  function handleChangeUsers(ev,newValue) {
        setForm({ ...form, "usersup": newValue });
  }

  useEffect(() => {
    loadAllUser();
  }, [location,name]);

  useEffect(() => {
  
      DirectionService.getDirection().then((res) => {
        if (res && res.status) {
          setDirection(res.data);
        }
      });
  
      //get all function
     FonctionService.getfonction().then((results) => {
        if (results && results.data) {
          setFonction(results.data);
        }
      });
  
      FundingService.getFunding().then((results) => {
        if (results && results.data) {
          setFunding(results.data);
        }
      });

     UserService.getAllGroup().then((result) => {
        if (result && result.data) {
          setTests(
            result.data.map((d) => {
              return { group_id: d.group_id, name: d.name, desc: d.desc };
            })
          );
        }
      });

    }, []);

  function handleChangeDirection(event) {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
    PlanningService.Direction(value).then((results) => {
      if (results && results.data) {
        setService(results.data);
        setServiceSupHierarchique(results.data);
      }
    })
  }

   function handleChangeService(ev) {
      const { name, value } = ev.target;
      setForm({ ...form, [name]: value });
   }

   function handleOnChangeFunction(name, value) {
    setForm({ ...form, [name]: value });
   }

   function handleOnChangeFunding(name, value) {
      setForm({ ...form, [name]: value });
   }


  function loadAllUser() {
    setOpenLoadingSimpleBackdrop(true);
    UserNotactifService.getUsernotactif(name).then((result) => {
      if (result && result.data) {
        setRows(result.data.map((row) => ({ ...row, id: row.user_id })));
        setOpenLoadingSimpleBackdrop(false);
      } else {
        setRows([]);
        setOpenLoadingSimpleBackdrop(false);
      }
    });
  }

   function handleSelectGroups() {
      UserService.getAllGroup().then((result) => {
        if (result && result.data) {
          setTests(
            result.data.map((d) => {
              return { group_id: d.group_id, name: d.name, desc: d.desc };
            })
          );
        }
      });
    }

  function handleCloseMessage() {
    setMessage({ ...message, openMessage: false });
  }

  const [open, setOpen] = React.useState(false);

 
  const handleClose = () => {
    setOpen(false);
  };

  const handleactiveperson = () => {
     const {
     person_id,
     direction_id,
     service_id,
     fonction_id,
     funding_id,
     email,
     registration_number,
     telephone,
     group,
     usersup,
     date_notif,
     date_prise,
     date_fin,
     motif
    } = form;
    if (
      !person_id ||
      direction_id === null ||
      service_id === null ||
      fonction_id === null ||
      funding_id === null ||
      !email ||
      !registration_number ||
      !telephone ||
      !Array.isArray(group) || group.length === 0 ||
      usersup === null ||date_notif===""||date_prise===""|| date_fin===""||motif===""
    ){
      setAfficheerreur(true);
   }
   else{
     setIsloading(true);
     UserNotactifService.saveperson(form).then((result) => {
      if (result) {
           setOpen(false);
           setIsloading(false);
           setMessage({ ...message, openMessage: true, color: 'green', messageInfo: "Succès" });
            navigate("/user_notactif");
      } else {
          setMessage({ ...message, openMessage: true, color: 'red', messageInfo: "Veuillez réessayer" });
          setOpen(false);
          setIsloading(false);
      }
    });
  }
    
  };

  const handleactive = (valeur) =>
  {
    setDetails(valeur);
    setForm({ ...form, 
      email:valeur.email,
      registration_number:valeur.registration_number,
      person_id:valeur.person_id
    });
    setOpen(true);
  }

   function handleBlurEmail(e) {
    if (!regexForEmail.test(e.target.value)) {
      setIsvalidEmail(true);
    }
  }

  const getItemLabel1 = (id) => {
    for (const row of tests) {
      if (row.group_id === id) {
        return row.name;
      }
    }
    return "";
  };

  function handleFocusEmail() {
    setIsvalidEmail(false);

  }

  function handleFocusPhoneNumber() {
    setIsPhoneNumberEmpty(false);
    setPhoneNumberLengthNotValid(false);
  }

  function handleChange1(ev) {
    const { name, value } = ev.target;
    if (name === 'telephone') {
      var i = 0;
      var a = 0;
      for (let index = 0; index < value.length; index++) {
        for (let indexs = 0; indexs < number.length; indexs++) {
          if (number[indexs] === value[index]) {
            i++;
          }
        }
      }
      if (i !== value.length) {
        setCompt(true);
      }
      else {
        setCompt(false);
        setForm({ ...form, [name]: value });
      }
    }
    else {
      setForm({ ...form, [name]: value });
    }
  }


  const columns = [
    {
      field: 'registration_number',
      headerName: 'Matricule',
      width: 150,
    },
    {
      field: 'full_name',
      headerName: 'Nom et prénom(s)',
      width: 300,
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 200,
    },
    {
      field: 'date_debut',
      headerName: 'Date de création',
      width: 190,
    },
     {
      field: 'date_desactive',
      headerName: 'Date de désactivation',
      width: 220,
    },
    {
      field: 'motif_statut',
      headerName: 'Motif de désactivation',
      width: 220,
    },
    {
      field: 'date_fin_contrat',
      headerName: 'Date de fin contrat',
      width: 220,
    },
    {
      field: 'action',
      headerName: 'Action',
      disableClickEventBulbing: true,
      renderCell: (params) => {
        return (
          <div>
            <Button  title="Activer un utilisateur" variant="contained" color="primary"  onClick={() => handleactive(params.row)}>
                <LockOpenIcon style={{ color: "black" }} /> Activer
            </Button>
          </div>
        );
      },
      width: 130,
    },
  ];
  return (
    <React.Fragment>
      <Message open={openMessage} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <Title>Liste des utilisateurs désactivés</Title>
      <div style={{ height: "70vh", width: '100%' }} className={classes.root} >
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[10, 100, 150, 200]}
          disableSelectionOnClick
        />
      </div>
      <div>
         <Dialog
           open={open}
           onClose={handleClose}
           fullWidth
           maxWidth="lg"
          >
         <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Réintégration du personnel:  {details.full_name}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
          <DialogContent dividers>
            <Grid container xs={12} spacing={1}>
                                  <Grid item xs={3}>
                                      <label class="aligneleft">Motif de réintegration *</label>
                                    </Grid>
                                    <Grid item xs={9}>
                                      <TextField
                                        fullWidth
                                        id="outlined-basic"
                                        size="small"
                                        label="Motif"
                                        variant="outlined" 
                                        onChange={handleChange1}
                                        value={form.motif}
                                        name="motif"
                                      />
                                    </Grid>
                                     <Grid item xs={12}></Grid>
                        <Grid item xs={3}>
                          <label class="aligneleft">Direction *</label>
                        </Grid>
                        <Grid item xs={9}>
                          <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="demo-simple-select-outlined-label" >
                              Direction
                            </InputLabel>
                            <Select labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              value={form.direction_id}
                              name="direction_id"
                              label="Direction"
                              onChange={handleChangeDirection}
                              >
                              {direction.map((row) => (
                                <MenuItem value={row.direction_id}>{row.code}</MenuItem>
    
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                         <Grid item xs={12}></Grid>
                         <Grid item xs={3}>
                                <label class="aligneleft">Service *</label>
                              </Grid>
          
                              <Grid item xs={9}>
                                <FormControl fullWidth variant="outlined" size="small">
          
                                  <InputLabel id="demo-simple-select-outlined-label" >
          
                                    Service
                              </InputLabel>
          
                                  <Select labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    value={form.service_id}
                                    name="service_id"
                                    onChange={handleChangeService}
                                    label="Service"
                                   >
                                    {service.map((row) => (
                                      <MenuItem value={row.service_id}>{row.code}</MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                          <Grid item xs={12}></Grid>
                          <Grid item xs={3}>
                              <label class="aligneleft">Poste *</label>
                            </Grid>
        
                            <Grid item xs={9}>
                              <Autocomplete
                                onChange={(event, newValue) => handleOnChangeFunction('fonction_id', newValue)}
                                options={fonction}
                                value={form.fonction_id}
                                name="fonction_id"
                                getOptionLabel={(option) => option?.name || ""}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    fullWidth
                                    label="Poste"
                                    size="small"
                                    variant="outlined"
                                    InputProps={{ ...params.InputProps, type: "search" }}
                                  />
                                )}
                              />
                             </Grid>
                              <Grid item xs={12}></Grid>
                               <Grid item xs={3}>
                                  <label class="aligneleft">Financement *</label>
                                </Grid>
                                <Grid item xs={9}>
                                  <Autocomplete
                                    onChange={(event, newValue) => handleOnChangeFunding('funding_id', newValue)}
                                    options={funding || []} 
                                    value={form.funding_id}
                                    getOptionLabel={(option) => option.code}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        fullWidth
                                        label="Financement"
                                        size="small"
                                        variant="outlined"
                                        InputProps={{ ...params.InputProps, type: "search" }}
                                      />
                                    )}
                                  />
                                </Grid>
                                <Grid item xs={12}></Grid>
                                 <Grid item xs={3}>
                                    <label>Matricule</label>
                                  </Grid>
                                  <Grid item xs={9}>
                                    <TextField
                                      fullWidth
                                      id="outlined-basic"
                                      size="small"
                                      label="Matricule"
                                      variant="outlined"
                                      value={form.registration_number}
                                      name="matricule"
                                      inputProps={{ style: { textTransform: "uppercase" } }}
                                      disabled
                                    />
                                  </Grid>
                                   <Grid item xs={12}></Grid>
                                    <Grid item xs={3}>
                                      <label class="aligneleft">Email *</label>
                                    </Grid>
                                    <Grid item xs={9}>
                                      <TextField
                                        fullWidth
                                        id="outlined-basic"
                                        size="small"
                                        label="email"
                                        variant="outlined" 
                                        onChange={handleChange1}
                                        onFocus={handleFocusEmail}
                                        onBlur={handleBlurEmail}
                                        error={!!isValidEmail}
                                        helperText={isValidEmail}
                                        value={form.email}
                                        name="email"
                                      />
                
                                      {isValidEmail && <div style={{ color: "red", textAlign: "left" }}><span>Adresse email invalide</span></div>}
                                    </Grid>
                                     <Grid item xs={12}></Grid>
                                    <Grid item xs={3}>
                                      <label>Téléphone</label>
                                    </Grid>
                                    <Grid item xs={9}>
                                      <Phone x1={3} x2={8} name="telephone" value={form.telephone} onChange={handleChange1} onFocus={handleFocusPhoneNumber} />
                                      {compt && <><Spacer y={1} /><Alert severity="error">Le numero de téléphone ne contient pas de lettres</Alert></>}
                                      {isPhoneNumberEmpty && <><Spacer y={1} /><Alert severity="error">Ce champ est obligatoire</Alert></>}
                                      {isPhoneNumberLengthNotValid && <><Spacer y={1} /><Alert severity="error">Veuillez vérifier votre numéro de téléphone. La longueur n'est pas valide</Alert></>}
                                    </Grid>
                              <Grid item xs={12}></Grid>
                           <Grid item xs={3}>
                            <label class="aligneleft">Groupes *</label>
                          </Grid>

                          <Grid item xs={9}>
                            <FormControl fullWidth variant="outlined" size="small">

                              <InputLabel id="demo-simple-select-outlined-label" >

                                Groupes
                          </InputLabel>

                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            multiple
                            onFocus={handleSelectGroups}
                            onChange={handleChange1}
                            value={form.group}
                            name="group"
                            label="Groupes"
                            renderValue={(selected) => (
                              <div className={classes.chips}>
                                {selected.map((value) => (
                                  <Chip
                                    key={value}

                                    label={getItemLabel1(value)}
                                    className={classes.chip}
                                  />
                                ))}
                              </div>
                            )}
                          >
                            {tests.map((row) => (
                              <MenuItem value={row.group_id}>
                                <Checkbox checked={form.group.includes(row.group_id)} />
                                 <ListItemText primary={row.name} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                         
                    </Grid>
                           <Grid item xs={3}>
                                  <label>Date de notification *</label>
                                </Grid>
                                 <Grid item xs={9}>
                                   <TextField
                                        label="Date de notification"
                                        type="date"
                                        fullWidth
                                        variant="outlined"
                                        name="date_notif"
                                        value={form.date_notif}
                                        onChange={handleChange1}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                    required
                                    />
                                 </Grid>
                                   <Grid item xs={3}>
                                  <label>Date de prise de fonction * </label>
                                </Grid>
                                 <Grid item xs={9}>
                                   <TextField
                                        label="Date de prise de fonction"
                                        type="date"
                                        fullWidth
                                        variant="outlined"
                                        name="date_prise"
                                        value={form.date_prise}
                                        onChange={handleChange1}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                    required
                                    />
                                 </Grid>
                                   <Grid item xs={3}>
                                  <label>Date fin de contrat * </label>
                                </Grid>
                                 <Grid item xs={9}>
                                   <TextField
                                        label="Date fin de contrat"
                                        type="date"
                                        fullWidth
                                        variant="outlined"
                                        name="date_fin"
                                        value={form.date_fin}
                                        onChange={handleChange1}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                         required
                                    />
                                    <hr/>
                                 </Grid>
                    
                     <Grid item xs={12}>
                       <h2> Superieur hierarchique </h2>
                     </Grid>
                     <Grid item xs={12}></Grid>
                      <Grid item xs={3}>
                          <label class="aligneleft">Direction *</label>
                        </Grid>
                        <Grid item xs={9}>
                          <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="demo-simple-select-outlined-label" >
                                Direction
                            </InputLabel>
                            <Select labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              value={form.direction_id}
                              name="direction_id"
                              label="Direction"
                              onChange={handleChangeDirection}
                              >
                              {direction.map((row) => (
                                <MenuItem value={row.direction_id}>{row.code}</MenuItem>
    
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                         <Grid item xs={12}></Grid>
                        <Grid item xs={3}>
                                <label>Service :</label>
                            </Grid>
                            <Grid item xs={9}>
                             <FormControl fullWidth variant="outlined" size="small">
                
                                <InputLabel id="demo-simple-select-outlined-label" >
                
                                Service
                                </InputLabel>
                
                                <Select labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={idserviceSupHierarchique}
                                name="service_id"
                                onChange={handleChangeServiceSupHierarchique}
                                label="Service" >
                                {serviceSupHierarchique.map((row) => (
                                    <MenuItem value={row.service_id}>{row.code}</MenuItem>
                                ))}
                                </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}></Grid>
                           <Grid item xs={3}>
                                  <label>Supérieur hiérarchique :</label>
                              </Grid>
                              <Grid item xs={9}>
                                   <FormControl fullWidth variant="outlined" size="small">
                                      <InputLabel id="demo-simple-select-outlined-label" >
                                         Supérieur hiérarchique
                                      </InputLabel>
                                            <Select
                                                  labelId="select-superieur-label"
                                                  id="select-superieur"
                                                  name="user_id"
                                                   value={users.find(option => option.user_id === form.usersup)?.user_id || ''}
                                                   onChange={(event) => handleChangeUsers(event, event.target.value)}
                                                  label="Supérieur hiérarchique"
                                              >
                                                  {users.map((option) => (
                                                      <MenuItem key={option.user_id} value={option.user_id}>
                                                          {`${option.first_name} ${option.last_name}`}
                                                      </MenuItem>
                                                  ))}
                                              </Select>
                                       </FormControl>
                              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button  variant="contained" color="secondary" onClick={handleClose}>
              ANNULER
            </Button>
           <LoadingButton
            variant="contained"
            color="primary"
            onClick={handleactiveperson}
            loading={isloading} 
          >
            Activer
          </LoadingButton>
          </DialogActions>
          </Dialog>
           <Dialog
              open={afficheerreur}
              onClose={handleCloseErreur}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="md"
            >
              <DialogTitle id="alert-dialog-title">
                    Champs manquants
              </DialogTitle>
              <DialogContent>
               <DialogContentText id="alert-dialog-description">
                  {
                    (() => {
                      const {
                        person_id,
                        direction_id,
                        service_id,
                        fonction_id,
                        funding_id,
                        email,
                        registration_number,
                        telephone,
                        group,
                        usersup
                      } = form;

                      const missingFields = [];

                      // Vérifie chaque champ et ajoute celui qui manque à la liste
                      if (!person_id) missingFields.push("Personne");
                      if (direction_id === null) missingFields.push("Direction");
                      if (service_id === null) missingFields.push("Service");
                      if (fonction_id === null) missingFields.push("Fonction");
                      if (funding_id === null) missingFields.push("Financement");
                      if (!email) missingFields.push("Email");
                      if (!registration_number) missingFields.push("Numéro d'enregistrement");
                      if (!telephone) missingFields.push("Téléphone");
                      if (!Array.isArray(group) || group.length === 0) missingFields.push("Groupe");
                      if (usersup === null) missingFields.push("Utilisateur supérieur");

                      return (
                        <p>
                          {missingFields.length > 0
                            ? (
                              <>
                                <span>Les champs suivants doivent être remplis :</span>
                                <ul>
                                  {missingFields.map((field, index) => (
                                    <li key={index}>{field}</li>
                                  ))}
                                </ul>
                              </>
                            )
                            : "Tous les champs sont remplis."}
                        </p>
                      );
                    })()
                  }
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseErreur} autoFocus>
                   OK
                </Button>
              </DialogActions>
            </Dialog>
      </div>
    </React.Fragment>
  );
}
